import React, { useEffect } from 'react'
import Navbar from '../components/Navbar'
import { Link } from 'react-router-dom'
import axios from 'axios'

const Logout = () => {
    useEffect(() => {
        const doLogout = async () => {
            try {
                const rawUserData = localStorage.getItem('userData');
                const parsed = rawUserData ? JSON.parse(rawUserData) : null;
                const token = parsed?.token || localStorage.getItem('token');

                if (token) {
                    await axios.post(
                        window.CARLOCA_API + '/auth/logout',
                        {},
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );
                }
            } catch (error) {
                // Local logout should still complete even if API logout fails.
            }

            localStorage.removeItem('userData');
            localStorage.removeItem('token');
            localStorage.removeItem('tokenData');
        };

        doLogout();
    }, [])

    return (
        <>
            <Navbar />
            <div
                className="d-flex align-items-center justify-content-center"
                style={{
                    minHeight: '100vh',
                    background: 'linear-gradient(135deg, #00889C 0%, #006d7e 100%)',
                    paddingTop: '70px',
                    paddingBottom: '30px',
                }}
            >
                <div className="col-lg-4 col-md-6 col-sm-9 col-11 mx-auto px-3">
                    <div
                        className="card border-0 shadow"
                        style={{ borderRadius: '16px', overflow: 'hidden' }}
                    >
                        <div className="card-body d-flex flex-column align-items-center justify-content-center py-4 px-4">
                            <img
                                src="/img/Logo_trusted_Cars.png"
                                alt="Trusted Cars Logo"
                                style={{ width: '50px', marginBottom: '15px' }}
                            />
                            <div
                                style={{
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '50%',
                                    background: 'linear-gradient(135deg, #00889C, #00b4d8)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: '15px',
                                    boxShadow: '0 4px 15px rgba(0, 136, 156, 0.3)',
                                }}
                            >
                                <i className="fas fa-check" style={{ fontSize: '28px', color: '#fff' }}></i>
                            </div>
                            <h5 className="text-center mb-1 fw-bold" style={{ color: '#00889C' }}>
                                See You Soon!
                            </h5>
                            <p className="text-center text-muted mb-3" style={{ fontSize: '0.9rem' }}>
                                You have been successfully logged out of your Trusted Cars account.
                            </p>
                            <div style={{ width: '40px', height: '2px', background: '#00889C', borderRadius: '2px', marginBottom: '20px' }}></div>
                            <Link
                                to="/"
                                className="btn mb-2 w-100 text-white fw-semibold"
                                style={{
                                    background: '#00889C',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '10px 20px',
                                    fontSize: '0.9rem',
                                    maxWidth: '280px',
                                }}
                            >
                                <i className="fas fa-home me-2"></i>Return To Home
                            </Link>
                            <Link
                                to="/login"
                                className="btn w-100 fw-semibold"
                                style={{
                                    background: 'transparent',
                                    border: '2px solid #00889C',
                                    color: '#00889C',
                                    borderRadius: '8px',
                                    padding: '10px 20px',
                                    fontSize: '0.9rem',
                                    maxWidth: '280px',
                                }}
                            >
                                <i className="fas fa-sign-in-alt me-2"></i>Login with another account
                            </Link>
                        </div>
                    </div>
                    <p className="text-center mt-3" style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.8rem' }}>
                        Thank you for using Trusted Cars
                    </p>
                </div>
            </div>
        </>
    )
}

export default Logout